import { getDateWithSpecificFormat } from '../../../../data-transform';
import { getStatusDescriptionFromStatusValue, getOrderTypeText } from '../../../../../utils/utility';

export default function indirectCustomerOrderListColumnsSpecification(config) {
    if (!config.data) return null;

    let result = {};
    let tableData = [];

    config.data.forEach((order, index) => {
        let row = [];
        const rowId = order.orderId;

        config.columns.forEach(column => {
            const columnId = column.id;
            const displayAsIs = column.data.displayInBodyAsIs;
            let columnDataType = column.data.displayInBodyAs;
            let importantData = null;
            let columnValue = null;
            let isDisabled = false;

            if (columnDataType === "string") {
                if (columnId === "orderId" && order.orderId) {
                    columnValue = order.orderId;
                }
                else if (columnId === "orderType") {
                    columnValue = getOrderTypeText(order.orderType) || "";
                }
                else if (columnId === "collectionDate") {
                    columnValue = getDateWithSpecificFormat(order.collectionDate) || "";
                }
                else if (columnId === "paymentStatus") {
                    columnValue = order.paymentStatus ? getStatusDescriptionFromStatusValue(order.paymentStatus) : "";
                }
                else if (columnId === "paymentDate") {
                    columnValue = order.paymentDate || "";
                }
                else if (columnId === "amount") {
                    columnValue = order.customerAmount === null || order.customerAmount === undefined ? 0 : order.customerAmount;
                    importantData = order.customerAmount < 0 ? "NegativeAmount" : "";
                }
                else if (column.id === "currencyCode") {
                    columnValue = order.currencyCode || "";
                }
            }
            else if (columnDataType === "icon") {
                if (column.id === "invoiceAndPaymentInstruction") {
                    columnValue = "download";
                    if (order.customerAmount === 0) {
                        columnValue = "";
                        columnDataType = "string";
                        isDisabled = true;
                    }
                }
            }

            row.push({
                [columnId]: {
                    id: columnId + "|" + rowId,
                    columnId: columnId,
                    type: columnDataType,
                    value: columnValue,
                    width: column.width,
                    displayAsIs: displayAsIs,
                    disabledCell: isDisabled,
                    importantData: importantData,
                    showInMobileViewAs: column.showInMobileViewAs,
                    clickHandler: (columnDataType !== "string" && config.bodyButtonsHandler) ? event => config.bodyButtonsHandler( rowId, order.customerAmount, index) : null
                }
            });
        });

        tableData.push({
            id: rowId,
            data: row
        });
    })

    result['columns'] = config.columns || [];
    result['data'] = tableData || [];
    return result;
}
